import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "knowledge-test__state-icon",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 1,
  class: "knowledge-test__score"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "/ 10", -1)
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["knowledge-test__state", { 'knowledge-test__state--passed': _ctx.passed }])
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.icon), 1))
      : _createCommentVNode("", true),
    (typeof _ctx.score === 'number')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("b", null, _toDisplayString(_ctx.score), 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.title)), 1),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.text)), 1))
      : _createCommentVNode("", true),
    (_ctx.buttonLabel)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          type: "button",
          class: "knowledge-test__button",
          disabled: _ctx.buttonDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
        }, _toDisplayString(_ctx.$t(_ctx.buttonLabel)), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ], 2))
}